import { useFormikContext } from 'formik'
import isEqual from 'lodash/isEqual'
import * as Analytics from 'core/common/analytics'
import { validateField, getErrorMessage } from 'core/common/utils/validation'
import { Typography } from 'core/components/Core'
import ProductUpload from 'core/containers/ProductUpload'
import { UploadProvider } from 'core/containers/ProductUpload/context'
import ProductImage from '../../../ProductUpload/components/ProductImage'

const UploadImageField = ({
  variationGroupList,
  formData,
  hasVariations,
  formMode,
  custom,
  setProgressState,
  isURLImageActive,
  handleEditStep,
  updateImages,
  step,
  setIsURLImageActive,
}) => {
  const { initialValues, errors, touched, submitCount, setFieldValue, values } = useFormikContext()

  const variationIndex = formData.variations.findIndex(
    item => item.id === variationGroupList?.[0]?.id
  )

  if (hasVariations && variationIndex === -1) return null

  const hasImageError = validateField(
    hasVariations ? `variations[${variationIndex}].images` : 'uploadedImages',
    errors,
    touched,
    submitCount > 0
  )

  if (hasImageError) {
    Analytics.ProductImageUploadError(formMode)
  }

  return (
    <UploadProvider
      initialImages={!hasVariations ? values.uploadedImages : variationGroupList?.[0]?.images}
      custom={custom}
    >
      {({ IS_SELECTABLE }) => {
        return (
          <div className="d-flex flex-column">
            <ProductUpload
              setProgressState={setProgressState}
              error={validateField(
                hasVariations ? `variations[${variationIndex}].images` : 'uploadedImages',
                errors,
                touched,
                submitCount > 0
              )}
              errorMessage={getErrorMessage(
                hasVariations ? `variations[${variationIndex}].images` : 'uploadedImages',
                errors,
                touched
              )}
              variation={false}
              onUpdateFiles={files => {
                if (!isEqual(values.uploadedImages, initialValues.uploadedImages)) {
                  handleEditStep(step.key)
                }

                if (files.find(file => file.uploadStatus === 'error')) {
                  Analytics.ProductImageUploadError(formMode)
                }

                if (!IS_SELECTABLE) {
                  updateImages({ variationGroupList, setFieldValue, files, values })
                } else {
                  const filteredFiles = variationGroupList?.[0]?.images.filter(file =>
                    files.some(findableFile => findableFile.id === file.id)
                  )
                  updateImages({
                    variationGroupList,
                    setFieldValue,
                    files: filteredFiles,
                    values,
                  })
                }
              }}
              onUploadComplete={files => {
                updateImages({ variationGroupList, setFieldValue, files, values })
                handleEditStep(step.key)
              }}
              style={{
                backgroundColor: '#F7F7F7',
                flex: 1,
                boxShadow: 'none',
              }}
              fullWidth
              hasWarning
              required
            />
            {isURLImageActive ? (
              <ProductImage
                className="my-3"
                onUploadComplete={files => {
                  updateImages({ variationGroupList, setFieldValue, files, values })
                }}
                label="Copie e cole o link da foto no campo abaixo."
                onImageError={() => {
                  Analytics.ProductImageUploadError(formMode)
                }}
              />
            ) : (
              <Typography
                color="primary"
                variant="caption"
                style={{ fontWeight: 400, marginTop: 4 }}
                onClick={() => setIsURLImageActive(true)}
                className="text-center cursor-pointer"
              >
                Inserir fotos via URL
              </Typography>
            )}
          </div>
        )
      }}
    </UploadProvider>
  )
}

export default UploadImageField
